<script>
/**
 * Name        :  
 * Type        : Page component
 * Title       : 스케쥴관리
 * Description : 운송수단의 스케쥴을 관리
 * 
 */

import Title from "@/components/admin/common/TitleArea.vue"

import Scheduler from "@/components/admin/logis/Scheduler.vue"


export default {
  name: "Admin-schedule-management",
  meta: {
    title: "어드민-스케쥴관리"
  },
  components: {
    Title,
    Scheduler,
  },
  data() {
    return {
      description   : {
        title : '일정관리'
      },
    }
  },
  methods: {
    triggerToday() {
      this.$refs.scheduler?.calendarToday()
    },
    triggerAddSchedule() {
      this.$refs.scheduler?.addSchedule()
    }
  }
}
</script>


<template>
  <q-page class="q-pa-lg">
    <div class="row">
      <div class="col">
        <Title
          :desc="description">
          <q-btn
            outline
            color="primary"
            icon="today"
            label="오늘"
            @click="triggerToday"
          />
          <q-btn
            class="q-ml-sm"
            color="primary"
            icon="add"
            label="일정 추가"
            @click="triggerAddSchedule"
          />
        </Title>
      </div>
    </div>

    <div class="row q-mt-lg">
      <div class="col">
        <Scheduler ref="scheduler">
        </Scheduler>
      </div>
    </div>
  </q-page>

</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
